<template>
  <section class="page-web" >
    <div v-if="cform === 'find'" v-html="information.content"></div>
    <div v-if="cform === 'cooperation'" v-html="information.content"></div>
    <div v-if="cform === 'salon'" v-html="information.introduction"></div>
    
</section>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.query.id,
      information: "",
      cform: this.$route.query.cform
    };
  },
  created() {
    if (!this.id) return false;
    this.getListData();
  },
  methods: {
    getListData() {
      console.log(this.id);
      if (this.cform === "find") {
        this.service.getDiscoveryWelcomeCaseList(this.id).then(res => {
          console.log(res);
          if (res.success) {
            this.information = res.data[0];
          }
        });
      }
      if (this.cform === "cooperation") {
        this.service.getCooperationCaseList(this.id).then(res => {
          console.log(res);
          if (res.success) {
            this.information = res.data[0];
          }
        });
      }
      if (this.cform === "salon") {
        this.service.salonList(this.id).then(res => {
          console.log(res);
          if (res.success) {
            this.information = res.data[0];
          }
        });
      }
    }
  }
};
</script>
<style>
.page-web img {
  width: 98% !important;
  height: inherit !important;
}
.page-web h5 h6,
.page-web h5 > *,
.page-web h6 > * {
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.page-web h1,
.page-web h1 > * {
  font-size: 0.5rem !important;
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.page-web h2,
.page-web h2 > * {
  font-size: 0.46rem !important;
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.page-web h3,
.page-web h3 > * {
  font-size: 0.42rem !important;
  letter-spacing: 0.06rem;
  color: #3a3f43 !important;
}
.page-web h4,
.page-web h4 > * {
  font-size: 0.38rem !important;
  letter-spacing: 0.06rem;
  color: #333 !important;
}
.page-web > div > p {
  font-size: 0.4rem !important;
  color: #666;
  letter-spacing: 0.02rem;
}
.page-web > div > p > span {
  font-size: 0.4rem;
  color: #666;
  letter-spacing: 0.02rem;
}

.page-web > div a {
  font-size: 0.4rem;
  color: #666;
  letter-spacing: 0.02rem;
}
strong {
  font-size: inherit !important;
}
</style>

<style lang="scss" scoped>
img {
  width: 100% !important;
}
.page-web {
  padding: 0.8rem 0.6rem;
  width: 100%;
  overflow: hidden;
  p img {
    width: 100px;
  }

  h1 {
    font-size: 0.5rem !important;
  }
}
</style>





// WEBPACK FOOTER //
// pageWeb.vue?53c62750